<template>
	<div id="slide-container">
		<div id="nav-prev" class="nav-slides" v-on:click="changeSlide('prev')">
			<img width="27" height="77" alt="Prev" src="../assets/title-screens/arrow-prev.png" />
		</div>
		<div id="slides">
			<div id="slide-panels">
				<div v-for="(slide, slideId) in slides" :key="slideId">
					<img width="930" v-bind:src="require(`@/assets/title-screens/${slides[slideId]}`)" v-bind:id="'slide-' + (+slideId + 1)" v-bind:class="{ 'active-slide' : isActive[ (+slideId + 1)] }" />
				</div>
			</div>

			<a id="abbvie-link" href="https://www.rxabbvie.com/pdf/venclexta.pdf" target="_blank"></a>

			<div id="slide-pagination">
				<div v-for="(slide, slideId) in slides" :key="slideId">
					<div class="slide-dot">
						<img width="23" height="23" src="../assets/title-screens/dot-active.png"
						v-bind:id="'slide-which-' + (+slideId + 1)" v-bind:class="{ 'active-slide' : isActive[ (+slideId + 1)] }" />
					</div>
				</div>
			</div>
		</div>
		<div id="nav-next" class="nav-slides" v-on:click="changeSlide('next')">
			<img width="27" height="77" alt="Next" src="../assets/title-screens/arrow-next.png" />
		</div>
	</div>
	<div id="get-started">
		<router-link v-bind:to="{ name: 'Navigation'}">
			<img width="245" height="64" src="../assets/title-screens/button-get-started.png" alt="Get Started" />
		</router-link>
	</div>
</template>
<script>
export default {
	data() {
		return {
			currentSlide: this.$route.params.id,
			isActive: [],
			slides: [
				'slide-1-sharpen-patient-2.png',
				'slide-2-explore-an-interactive-2.png',
				'slide-3-get-to-know-2.png',
				'slide-4-understand-how-to-2.png',
				'slide-5-recognize-key-initiation-2.png',
				'slide-6-guide-patients-experiencing-2.png'
			],
			slideChange: null
		}
	},
	methods: {
		changeSlide(dir){
			this.isActive[this.$route.params.id] = false
			let routeSlideNo = this.$route.params.id

			if(dir === 'prev'){
				this.currentSlide = +routeSlideNo - 1
			} else {
				this.currentSlide = +routeSlideNo + 1
			}

			if(this.currentSlide === 0){
				this.currentSlide = this.slides.length
			} else if(this.currentSlide > this.slides.length){
				this.currentSlide = 1
			}

			this.isActive[this.currentSlide] = true
			this.$router.push('/title-screen/' + this.currentSlide)
		},
		autoRotate(action){
			var this_ = this

			if(action === 'run'){
				this_.slide_change = setInterval(function(){ 
					this_.changeSlide(this_.currentSlide + 1)
				},6000);
			} else if(action === 'stop') {
				clearInterval(this_.slide_change)
			}

		}
	},
	mounted() {
		this.autoRotate('run')
	},
	beforeUnmount() {
		this.autoRotate('stop')
	},
	created(){
		this.isActive[this.$route.params.id] = true
	}
}
</script>
<style scoped>
#slide-container {
	min-height: 533px;
}
	#slide-container img {
		position: absolute;
	}

.nav-slides {
	cursor: pointer;
	width: 50px;
}

#slides {
	position: relative;
	width: 930px;
}

	#slides img {
		opacity: 0;
		transition: all 999ms ease-in-out;
		/* transform: translateX(6px); */
	}

		#slides img.active-slide {
			opacity: 1;
		}

	#slide-pagination {
		display: flex;
		position: absolute;
		right: 54px;
		bottom: 3px;
	}

		.slide-dot {
			background: url(../assets/title-screens/dot-inactive.png) no-repeat;
			background-size: contain;
			margin: 0 6px;
			width: 23px;
			height: 23px;
		}

#get-started {
	margin: 9px auto 0;
	text-align: center
}

	#get-started img {
		display: block;
		margin: 0 auto;
	}

#abbvie-link {
	bottom: 57px;
	left: 528px;
	position: absolute;
	width: 94px;
	height: 21px;
}
</style>